<template>
  <div class="user-settings-page">
    <block-buttons
      title="Настройки пользователя"
      description="Личные данные и безопасность аккаунта"
    >
      <template #icon>
        <UserCog :size="22" />
      </template>
    </block-buttons>

    <settings-card
      title="Дополнительные операции"
      description="Сброс локальных данных и др."
    >
      <template #icon>
        <Cog :size="22" />
      </template>

      <div class="settings-button">
        <button
          class="settings-submit"
          type="button"
          @click="resetData"
        >
          Сброс локальных данных
        </button>

        <p>* сбрасывает сохраненные локально данные аккаунта(Настройки, Товары, Рабочие смены, Категории, Пользовательские данные и др)</p>
      </div>
    </settings-card>

    <div class="user-settings-page__sections">
      <settings-card
        title="Личные данные"
        description="Измените имя и фамилию в профиле"
      >
        <template #icon>
          <UserRound :size="22" />
        </template>

        <profile-form
          :user="user"
          :disabled="isDisabled"
          :saving="saving === 'profile'"
          @save="updateProfileData"
        />
      </settings-card>

      <settings-card
        title="Пароль"
        description="Для смены пароля укажите текущий пароль"
      >
        <template #icon>
          <LockKeyhole :size="22" />
        </template>

        <password-form
          ref="passwordForm"
          :disabled="isDisabled"
          :saving="saving === 'password'"
          @save="updatePassword"
        />
      </settings-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { UserCog, UserRound, LockKeyhole, Cog } from 'lucide-vue'

import BlockButtons from '@/components/blockButtons'
import SettingsCard from './components/SettingsCard.vue'
import ProfileForm from './components/ProfileForm.vue'
import PasswordForm from './components/PasswordForm.vue'

export default {
  name: 'UserSettingsPage',
  components: {
    BlockButtons,
    SettingsCard,
    ProfileForm,
    PasswordForm,
    UserCog,
    UserRound,
    LockKeyhole,
    Cog
  },
  data () {
    return {
      saving: '',
      isSubmitting: false
    }
  },
  computed: {
    ...mapGetters('user', { user: 'getData' }),
    isDisabled () {
      return Boolean(this.saving) || !this.user.id
    }
  },
  methods: {
    ...mapActions('user', ['change', 'changePassword', 'logout']),
    ...mapActions('config', ['resetLocalStore']),
    async updateProfileData (updatedData) {
      await this.$bus.emit('start-loader')
      this.isSubmitting = true

      const { error } = await this.change(updatedData)

      await this.$bus.emit('stop-loader')
      this.isSubmitting = false

      if (error) {
        this.$notify({
          type: 'error',
          title: 'Произошла ошибка!',
          text: `Произошла ошибка: ${error.message}`,
          clean: false,
          duration: 3000
        })

        return
      }

      this.$notify({
        type: 'success',
        title: 'Ура!',
        text: 'Данные успешно обновлены!',
        clean: false,
        duration: 3000
      })
    },
    async updatePassword (updatedData) {
      await this.$bus.emit('start-loader')
      this.isSubmitting = true

      const { error } = await this.changePassword(updatedData)

      await this.$bus.emit('stop-loader')
      this.isSubmitting = false

      if (error) {
        this.$notify({
          type: 'error',
          title: 'Произошла ошибка!',
          text: `Произошла ошибка: ${error.message}`,
          clean: false,
          duration: 3000
        })

        return
      }

      this.$notify({
        type: 'success',
        title: 'Ура!',
        text: 'Пароль успешно обновлен!',
        clean: false,
        duration: 3000
      })

      await this.logout()
      await this.$router.push('/auth')
    },
    async resetData () {
      localStorage.clear()
      await this.resetLocalStore()
      await this.$nextTick()
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" src="./style.scss" />
